<template>
  <div>
    <vue-element-loading :active="loadingLanguage" :is-full-screen="true" />
    <b-nav-item-dropdown right>
      <template slot="button-content">
        <flag
          :iso="isoCode(active_lang.langtag)"
          :squared="false"
          :title="active_lang.name"
        />
      </template>
      <b-dropdown-item
        v-for="(value, key) in available_langs"
        :key="key"
        @click="switchLang(value)"
      >
        <flag
          class="mr-3"
          :iso="isoCode(value.langtag)"
          :squared="false"
          :title="isoCode(value.langtag)"
        />
        <span class="lang-item">{{ value.name }}</span>
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      loadingLanguage: false,
    };
  },
  computed: {
    ...mapState({
      authenticated: (state) => state.auth.authenticated,
      available_langs: (state) => state.i18nmap.available_langs,
      active_lang: (state) => state.i18nmap.active_lang,
    }),
  },
  methods: {
    ...mapActions({
      LOAD_PUBLIC_CATEGORIES_TRANSLATIONS:
        "i18nmap/LOAD_PUBLIC_CATEGORIES_TRANSLATIONS",
      LOAD_PUBLIC_LANGUAGE_TRANSLATIONS:
        "i18nmap/LOAD_PUBLIC_LANGUAGE_TRANSLATIONS",
    }),
    isoCode(langtag) {
      var code = (langtag && langtag.split(/[_,-]/)[1]) || "";
      if (code == "Latn") {
        code = (langtag && langtag.split(/[_,-]/)[0]) || "";
      }
      if (code === "EN") {
        code = "GB";
      }

      return code;
    },

    switchLang(langpayload) {
      let promises = [];

      this.loadingLanguage = true;

      const categoriesPromise = this.LOAD_PUBLIC_CATEGORIES_TRANSLATIONS({
        langtag: langpayload.langtag,
      });
      promises.push(categoriesPromise);

      const translationsPromise = this.LOAD_PUBLIC_LANGUAGE_TRANSLATIONS({
        langtag: langpayload.langtag,
      });
      promises.push(translationsPromise);

      Promise.all(promises)
        .then(
          () => {
            this.$store.commit("i18nmap/SWITCH_ACTIVE_LANG", {
              langtag: langpayload.langtag,
            });
            this.$store.commit(
              "i18nmap/MUTATE_USER_SETTINGS_LANGTAG",
              langpayload.langtag
            );
            this.loadingLanguage = false;
          },
          (err) => {
            this.$sentry({ capture: err });
            this.mnotify_error({
              text: this.$t("language_selector.error.cannot_switch_language"),
            });
            this.loadingLanguage = false;
          }
        )
        .catch((err) => {
          this.loadingLanguage = false;
          this.$sentry({ capture: err });
          this.mnotify_error({
            text: this.$t("language_selector.error.cannot_switch_language"),
          });
        });
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        language_selector: {
          error: {
            cannot_switch_language: "Cannot switch language",
          },
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .dropdown-menu {
  overflow-y: scroll;
  max-height: 170px;
  padding: 0 !important;

  .dropdown-item {
    border-bottom: 1px solid $nav-bar-langs-divider-color;
    color: $nav-bar-lang-color;
    padding: 10px 20px;
    text-decoration: none;
  }

  .dropdown-item:hover,
  .dropdown-item:focus {
    color: $nav-bar-lang-focus-color;
    background-color: $nav-bar-lang-focus-bg-color;
  }

  .dropdown-item .lang-item {
    font-size: 0.9rem;
  }
}
</style>
